import { get, put } from '@/shared/utils/fetchApi';

/**
 * Serviço para gerenciar execuções de nós
 * Implementa o padrão Facade para encapsular as chamadas à API relacionadas a execuções de nós
 */
export class NodeExecutionService {
  private static BASE_URL = '/node-execution';

  /**
   * Verifica o status de execução de um nó pelo ID
   * Substitui a consulta direta ao Supabase:
   * supabase.from('node_execution').select('*').eq('id', executionId).single()
   * 
   * @param executionId ID da execução
   * @returns Status da operação no formato { data, error }
   */
  static async getById(executionId: string): Promise<{data: Record<string, unknown> | null, error: Error | null}> {
    try {
      const result = await get<{data: Record<string, unknown>}>(`${this.BASE_URL}/${executionId}`);
      
      return { data: result.data, error: null };
    } catch (error) {
      return { data: null, error: error instanceof Error ? error : new Error(String(error)) };
    }
  }

  /**
   * Atualiza o status de execução de um nó
   * Substitui a consulta direta ao Supabase:
   * supabase.from('node_execution').update({ status, ...(output && { output }) }).eq('id', executionId)
   * 
   * @param executionId ID da execução
   * @param status Novo status
   * @param output Saída da execução (opcional)
   * @returns Status da operação no formato { data, error }
   */
  static async updateStatus(executionId: string, status: string, output?: unknown): Promise<{data: Record<string, unknown> | null, error: Error | null}> {
    try {
      const body: Record<string, unknown> = {
        status,
        ...(output !== undefined && { output })
      };

      const result = await put<{data: Record<string, unknown>}>(`${this.BASE_URL}/${executionId}`, body);

      return { data: result.data, error: null };
    } catch (error) {
      return { data: null, error: error instanceof Error ? error : new Error(String(error)) };
    }
  }
}
